import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const DictionaryConvertToast = ({ dictionaryName, isNew }) => (
  <PositiveToast className="aridhia-dataset-convert-toast">
    <FormattedMessage
      id={isNew ? 'dataset.convert.toast.create.success' : 'dataset.convert.toast.update.success'}
      values={{ dictionaryName }}
    />
  </PositiveToast>
);

export default DictionaryConvertToast;
